module.exports = __webpack_public_path__ + "static/media/logo.12556df3.png";